import { Page, PageTitle } from "@/components/page"
import { BarChart3 } from "lucide-react"
import { TelerivetDashboardSection } from "./components/telerivet-dashboard-section"

export const dashboard = {
  title: "Dashboard",
  description: "Visualize conversation analytics across your channels",
  route: "/dashboard",
  url: "/dashboard",
  icon: BarChart3,
  component,
  resource: "dashboard",
  action: "read",
} satisfies PageConfig

function component() {
  return (
    <Page>
      <div className="space-y-6">
        <PageTitle />
        <TelerivetDashboardSection />
      </div>
    </Page>
  )
}

